import React from 'react'
import PropTypes from 'prop-types'

import { Footer } from 'components'

import styles from './Layout.module.css'

const Layout = ({ children }) => {
  const { content } = styles

  return (
    <>
      <div className={content}>{children}</div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
